import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { IncidentNature } from '@app/shared/enums/incident-nature.enum';
import { getIncidentNatureImage } from '@app/shared/utils/get-enum/get-incident-nature';
import { AttachmentApiModel } from '@app/api/api-models/attachments/AttachmentApiModel';

import { IncidentPerformanceCategoryApiModel } from './IncidentPerformanceCategoryApiModel';

export class IncidentApiModel {
  public FormInstanceId: number;
  public IncidentTypeId: string;
  public IncidentTypeName: string;
  public Nature: IncidentNature;
  public Number: string;
  public Description: string;
  public CorrectiveActionId: string;
  public CorrectiveActionName: string;
  public PerformanceCategories: IncidentPerformanceCategoryApiModel[];
  public Attachments: AttachmentApiModel[];

  public imgSrc: SafeResourceUrl;

  public deserialize(data: object, domSanitizer: DomSanitizer): this {
    Object.assign(this, data);

    this.imgSrc = getIncidentNatureImage(this.Nature, domSanitizer);

    return this;
  }
}
